import * as React from 'react';
import { formatCurrency } from '../../../utils/currency-formatter';
import { toShortDate } from '../../../utils/date-utils';
import { AgingReport, AgingReportInvoice } from "../models/credit-hold-aging-report"

interface IProps {
    report : AgingReport|undefined;
}

export const CreditHoldAgingReport = (props : IProps) => {

    const fillCell = (order : AgingReportInvoice, start:number, end:number) => {
        if(start === 0 && end === 0 && order.daysOverdue <= 0) {
            return order.amount < 0 ? `(${formatCurrency(Math.abs(order.amount)) })` : formatCurrency(order.amount);
        }
        else if(order.daysOverdue >= start && order.daysOverdue <= end) {
            return order.amount < 0 ? `(${formatCurrency(Math.abs(order.amount)) })` : formatCurrency(order.amount);
        }
        else {
            return '-';
        }
    };

    return ( 
        props.report ?
            <>
                <div className="row mb-3">
                    <div className="col aging-report">
                        <p className="text-right">Total Due: { formatCurrency(props.report.total) }</p>
                        <p className="text-right">Credit Limit: { formatCurrency(props.report.creditLimit) }</p>
                        <p className="text-right">RSM: { props.report.rsmName } ({ props.report.regionId })</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className="aging-legend">
                            <h4 className="current">
                                <span>Current:</span> 
                                <span>{ formatCurrency(props.report.getCurrent().amount) } [{ props.report.getCurrent().count }]</span>
                            </h4>
                            <h4 className="zeroThirty">
                                <span>1-30:</span> 
                                <span>{ formatCurrency(props.report.getOneThirty().amount) } [{ props.report.getOneThirty().count }]</span>
                            </h4>
                            <h4 className="thirtySixty">
                                <span>31-60:</span> 
                                <span>{ formatCurrency(props.report.getThirtySixty().amount) } [{ props.report.getThirtySixty().count }]</span>
                            </h4>
                            <h4 className="sixtyNinety">
                                <span>61-90:</span> 
                                <span>{ formatCurrency(props.report.getSixtyNinety().amount) } [{ props.report.getSixtyNinety().count }]</span>
                            </h4>
                            <h4 className="ninetyOneTwenty">
                                <span>91-120:</span>
                                <span>{ formatCurrency(props.report.getNinetyOneTwenty().amount) } [{ props.report.getNinetyOneTwenty().count }]</span> 
                            </h4>
                            <h4 className="oneTwentyBeyond">
                                <span>120+:</span> 
                                <span>{ formatCurrency(props.report.getOneTwentyPlus().amount) } [{ props.report.getOneTwentyPlus().count }]</span>
                            </h4>
                        </div>
                    </div>

                </div>
            
                <div className="row">
                    <div className="col">

                    <div className="aging-data-point-container">
                    <div className="datum current" 
                        style={{ 
                            width: props.report.getCurrent().percentage + '%', 
                            left: 0 
                        }}
                    />

                    <div className="datum zeroThirty" 
                        style={{ 
                            width: props.report.getOneThirty().percentage + '%',  
                            left: (props.report.getCurrent().percentage) + '%' 
                        }} 
                    />

                    <div className="datum thirtySixty" 
                        style={{ 
                            width: props.report.getThirtySixty().percentage + '%',  
                            left: (props.report.getCurrent().percentage + props.report.getOneThirty().percentage) + '%' 
                        }} 
                    />

                    <div className="datum sixtyNinety" 
                        style={{ 
                            width: props.report.getSixtyNinety().percentage + '%', 
                            left: (props.report.getCurrent().percentage + props.report.getOneThirty().percentage + props.report.getThirtySixty().percentage) + '%' 
                        }} />

                    <div className="datum ninetyOneTwenty" 
                        style={{ 
                            width: props.report.getNinetyOneTwenty().percentage + '%',  
                            left: (props.report.getCurrent().percentage + props.report.getOneThirty().percentage + props.report.getThirtySixty().percentage + props.report.getSixtyNinety().percentage) + '%' 
                        }} 
                    />

                    <div className="datum oneTwentyBeyond" 
                        style={{ 
                            width: props.report.getOneTwentyPlus().percentage + '%',  
                            left: (props.report.getCurrent().percentage + props.report.getOneThirty().percentage + props.report.getThirtySixty().percentage + props.report.getSixtyNinety().percentage + props.report.getNinetyOneTwenty().percentage) + '%' 
                        }} 
                    />

                </div>

                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Invoice Number</th>
                                    <th>Invoice Date</th>
                                    <th>Due Date</th>
                                    <th>Current <span className="pastdue current"></span></th>
                                    <th>1-30 <span className="pastdue zeroThirty"></span></th>
                                    <th>31-60 <span className="pastdue thirtySixty"></span></th>
                                    <th>61-90 <span className="pastdue sixtyNinety"></span></th>
                                    <th>91-120 <span className="pastdue ninetyOneTwenty"></span></th>
                                    <th>120+ <span className="pastdue oneTwentyBeyond"></span></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    props.report.invoices.map((itm : AgingReportInvoice) => 
                                        <tr key={ itm.invoiceNumber }>
                                            <td>{ itm.invoiceNumber }</td>
                                            <td>{ itm.invoiceDate ? toShortDate(itm.invoiceDate) : '' }</td>
                                            <td>{ itm.dueDate ? toShortDate(itm.dueDate) : '' }</td>
                                            <td className={ itm.amount < 0 ? 'credit-given' : '' }>{ fillCell(itm, 0, 0) }</td>
                                            <td className={ itm.amount < 0 ? 'credit-given' : '' }>{ fillCell(itm, 1, 30) }</td>
                                            <td className={ itm.amount < 0 ? 'credit-given' : '' }>{ fillCell(itm, 31, 60) }</td>
                                            <td className={ itm.amount < 0 ? 'credit-given' : '' }>{ fillCell(itm, 61, 90) }</td>
                                            <td className={ itm.amount < 0 ? 'credit-given' : '' }>{ fillCell(itm, 91, 120) }</td>
                                            <td className={ itm.amount < 0 ? 'credit-given' : '' }>{ fillCell(itm, 121, 1000000) }</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                </div>        
            </>
        : null
    )

}